import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Col, FormGroup, Input, Label, Row, FormFeedback } from 'reactstrap'
import Select from 'react-select'
import { I18n } from 'react-redux-i18n'
import { STYLES_REACT_SELECT_NEW } from '../../../../constants'
import { setCampaignData } from 'redux/actions/marketing'
import { isValidText } from 'utils/helpers'
import { TextNumberFormat } from 'components/Form'

const Step1 = ({ error }) => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state.marketing.campaign)
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (error) {
      setErrors(error)
    }
    return () => setErrors({})
  }, [error])

  const handleChange = ({ target }) => {
    if (errors) setErrors({})

    const { name, value } = target
    if (isValidText(value)) dispatch(setCampaignData({ ...state, [name]: value }))
  }

  const handleSelect = ({ value }) => {
    if (errors.durationLabel) setErrors({})
    dispatch(setCampaignData({ ...state, durationLabel: value }))
  }

  return (
    <div>
      <h1>{I18n.t('create_campaign_campaign_data')}</h1>
      <p className='summary'></p>

      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label for='name' className={'floating-label'}>
              {I18n.t('create_campaign_campaign_name')}
            </Label>
            <Input
              type='text'
              defaultValue={state.name}
              name='name'
              id='name'
              onChange={handleChange}
              className={'new-input name'}
              required
              invalid={!!errors.name}
            />
            <FormFeedback>{errors['name'] || errors.global}</FormFeedback>
            <small className='form-text text-muted'>{I18n.t('dashboard_christmas-example')}</small>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={5}>
          <FormGroup>
            <Label className='new-label'>{I18n.t('create_campaign_campaign_duration')}</Label>
            <Row className={'padding-left-15'}>
              <Col xs={3} style={{ paddingLeft: 0, display: 'contents' }}>
                <Input
                  type='number'
                  defaultValue={state.duration}
                  name='duration'
                  id='number'
                  min={1}
                  onChange={handleChange}
                  required
                  invalid={!!errors.duration}
                  className='new-input days'
                />
              </Col>
              <Col xs={9} style={{ paddingLeft: 0 }}>
                <Select
                  onChange={handleSelect}
                  value={{ value: state.durationLabel, label: I18n.t(`dashboard_${state.durationLabel || 'days'}`) }}
                  options={[
                    { option: 1, label: I18n.t('dashboard_days'), value: 'days' },
                    { option: 2, label: I18n.t('dashboard_weeks'), value: 'weeks' },
                    { option: 3, label: I18n.t('dashboard_months'), value: 'months' },
                  ]}
                  styles={{ ...STYLES_REACT_SELECT_NEW }}
                />
                <Input type='text' hidden={true} invalid={!!errors.durationLabel} />
                {/* <FormFeedback>{error['durationLabel'] || error.global}</FormFeedback> */}
              </Col>
            </Row>
            <small className='form-text text-muted'>{I18n.t('dashboard_7-days-example')}</small>
            <FormFeedback>{error['duration'] || error.global}</FormFeedback>
            <FormFeedback>{error['durationLabel'] || error.global}</FormFeedback>
          </FormGroup>
        </Col>

        <Col xs={4}>
          <FormGroup>
            <Label for='cost' className='new-label'>
              {I18n.t('create_campaign_cost')}
            </Label>
            <div style={{ position: 'relative' }}>
              <TextNumberFormat
                defaultValue={state.cost}
                id='cost'
                customInput={Input}
                onChange={value => handleChange({ target: { name: 'cost', value: isNaN(value) ? 0 : value } })}
                className={'new-input'}
              />
              <span className='input-group-text wrapper-icon-euro'>
                <i className='fa fa-eur'></i>
              </span>
            </div>
            <small className='form-text text-muted'>{I18n.t('dashboard_500-eur-example')}</small>
          </FormGroup>
        </Col>
      </Row>
    </div>
  )
}

export default connect()(Step1)
